import styles from "components/address/Address.module.scss";
import classNames from "classnames";
import { trim } from "lodash";
import React, { FC } from "react";

interface IProps {
    addressLine?: string | null;
    deliveryType?: string | null;
    deliveryNumber?: string | null;
    suburb?: string | null;
    state?: string | null;
    postcode?: string | null;
    country?: string | null;
    className?: string;
}

export const AddressSummary: FC<IProps> = ({
    country,
    postcode,
    state,
    addressLine,
    deliveryType,
    deliveryNumber,
    suburb,
    className,
    children,
}) => {
    const streetLine = trim(`${!addressLine ? "" : addressLine}`);
    const postalLine = trim(`${!deliveryType ? "" : deliveryType} ${!deliveryNumber ? "" : deliveryNumber}`);

    return <div className={classNames(styles.addressSummary, className)}>
        {postalLine && <div>{postalLine}</div>}
        {streetLine && <div>{streetLine}</div>}
        {suburb && <div>{suburb}</div>}
        {(state || postcode) && <div>{state} {postcode}</div>}
        {country && <div>{country}</div>}
        {children}
    </div>;
};
